import React from "react"
import { Badge } from "react-bootstrap"
import { FormattedMessage, injectIntl } from "react-intl"
type ItemSKUProps = {
    SKU: string
}


const ItemSKU = (props: ItemSKUProps) => {

    return <div className={"d-flex flex-wrap pb-1"}>
        <Badge
            className={"p-1"}
            variant="dark">
            <FormattedMessage
                id={"quote.component.item_sku"}
                defaultMessage={"SKU: {SKU}"}
                values={{
                    SKU: props.SKU
                }}
            />
        </Badge>
    </div>
}

export default injectIntl(ItemSKU)


// WEBPACK FOOTER //
// ./src/common/quote/component/ItemSKU.tsx